import styled from "styled-components";

export const TvlParticipant = styled.div`
  margin: 0 -8px 5%;

  .tvlParticipants {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${(props) =>
      props.large
        ? props.theme.palette.common.background
        : props.theme.palette.common.mainBackground};
    margin: 0px 7px 0px 7px;
    border-radius: 5px;
    text-align: center;
    height: ${(props) => (props.large ? "80px" : "")};
  }
  .p1 {
    font-size: 12px;
    margin: 0px;
    margin-top: 10px;
    color: ${(props) => props.theme.palette.common.text.secondary};
    font-weight: 600;
  }
  .p2 {
    color: ${(props) => props.theme.palette.card.text.primary};
    font-weight: 600;
    margin-top: 7px;
  }

  @media (max-width: 600px) {
    margin: 20px 0px;
  }
`;
